import { useEffect, useState } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";

export function useXOLeaderboards() {
    const [iq, setIq] = useState([]);
    const [cash, setCash] = useState([]);
    useEffect(() => {
        // Query finished games only
        const q = query(collection(db, "games"), where("status", "==", "finished"));
        const unsub = onSnapshot(q, (snap) => {
            const games = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

            // --- IQ Leaderboard: count win count per user ---
            const userStats = {};
            for (const g of games) {
                if (g.winner && g.winner !== "draw") {
                    if (!userStats[g.winner]) {
                        userStats[g.winner] = { wins: 0, cash: 0, username: "", avatar: "" };
                    }
                    userStats[g.winner].wins += 1;
                    userStats[g.winner].cash += Number(g.betAmount || 0.5);
                    // Get user info
                    const player =
                        g.playerX?.userId === g.winner ? g.playerX : g.playerO;
                    userStats[g.winner].username = player?.username || "User";
                    userStats[g.winner].avatar = player?.avatar || "";
                }
            }
            // IQ: sorted by wins
            const iq = Object.entries(userStats)
                .map(([userId, stat], idx) => ({
                    userId,
                    username: stat.username,
                    avatar: stat.avatar,
                    value: stat.wins,
                    win: stat.wins,
                    cash: stat.cash,
                    rank: 1, // will sort below
                }))
                .sort((a, b) => b.value - a.value)
                .slice(0, 10)
                .map((u, i) => ({ ...u, rank: i + 1 }));

            // Cash: sorted by cash won
            const cashL = [...iq]
                .sort((a, b) => b.cash - a.cash)
                .map((u, i) => ({ ...u, rank: i + 1 }));

            setIq(iq);
            setCash(cashL);
        });
        return unsub;
    }, []);
    // console.log("IQ Leaderboard:", iq);
    // console.log("Cash Leaderboard:", cash);
    return { iq, cash };
}
